import styles from './ModifierBadge.module.scss';

export interface ModifierBadgeProps {
	count: number;
}

export const ModifierBadge = (props: ModifierBadgeProps) => {
	const { count } = props;

	if (count === 0) return null;

	return (
		<span
			className={styles.badge}
			aria-label={`${count} modifier${count === 1 ? '' : 's'} configured`}
			data-testid='@Ofload-ModifierBadge'
		>
			{count}
		</span>
	);
}
